export class PageResult<TModel> {
  content: TModel[];
  pageable: {
    sort: {
      sorted: boolean;
      unsorted: boolean;
    };
    pageSize: number;
    pageNumber: number;
    offset: number;
    unpaged: boolean;
    paged: boolean;
  };
  first: boolean;
  last: boolean;
  totalElements: number;
  totalPages: number;
  numberOfElements: number;
  size: number;
  number: number;
  sort: {
    sorted: boolean;
    unsorted: boolean;
  };
}


export class PageRequest {
  page: number;
  size: number;
  sortField: string;
  sortOrder: 'asc'|'desc';
  sort: string;

  constructor() {
    this.page = 0;
  }

  dataManipulation(): void {
    this.sort = '';
    if (this.sortField != null && this.sortOrder != null) {
      this.sort = this.sortField + ',' + this.sortOrder;
    }
  }

  next(): void {
    this.page = this.page + 1;
  }

  prev(): void {
    this.page = this.page - 1;
  }
}
